import rawCountryList from "@climatepartner/assets/constants/countries.json";
import { CONTINENT_ISO_CODES } from "@service/string-constants";

import { GLOBAL_REGION } from "../calculations/calculation-factor-types";

export type Region = {
  name: string;
  isoCode: string;
};

export type Country = Region;

export const countryList: Country[] = rawCountryList
  .map((country) => ({
    name: country.label,
    isoCode: country.id,
  }))
  .sort((a, b) => (a.name > b.name ? 1 : -1));

export const isoAlpha3ByIsoCode: Record<string, string> = Object.fromEntries(
  rawCountryList.map((country) => [country.id, country.iso3_code])
);

export const getCountryName = (countryIsoCode: string): string => {
  return countryList.find((c) => c.isoCode === countryIsoCode)?.name ?? countryIsoCode;
};

export const getFullRegionsList = (): Region[] => {
  return [{ name: "Global", isoCode: GLOBAL_REGION }].concat(generateContinentalList()).concat(countryList);
};

// Shared with the backend so the codes the selectors offer are the codes it validates.
const generateContinentalList = () =>
  CONTINENT_ISO_CODES.map((continent) => ({
    name: continent.split("-")[0],
    isoCode: continent,
  }));

const regionNamesByIsoCode = new Map(getFullRegionsList().map((region) => [region.isoCode, region.name]));

export const getRegionName = (regionIsoCode: string): string =>
  regionNamesByIsoCode.get(regionIsoCode) ?? regionIsoCode;

// The selected origin can be a country or a continent, so the code is resolved against both.
export const isRegionMatch = (region: string, regionIsoCode?: string): boolean =>
  regionIsoCode !== undefined && region.toLowerCase() === getRegionName(regionIsoCode).toLowerCase();
